// Treffer der Suche im Verlauf hervorheben (Runde 7B, L55), ohne die Seite umzubauen: die „CSS Custom Highlight API“ färbt Textstellen
// ein, ohne Knoten zu verändern (React bleibt unberührt). Gesucht wird wie im Server: ohne Groß-/Kleinschreibung, Umlaute und Akzente egal,
// jedes Wort einzeln. Wo der Browser die Schnittstelle nicht kennt, bleibt der Verlauf einfach ohne Färbung.

const NAME = "ls-treffer";

type HighlightKlasse = new (...ranges: Range[]) => unknown;
interface HighlightSpeicher {
  set: (name: string, wert: unknown) => void;
  delete: (name: string) => void;
}

function schnittstelle(): { Highlight: HighlightKlasse; speicher: HighlightSpeicher } | null {
  const h = (window as unknown as { Highlight?: HighlightKlasse }).Highlight;
  const s = (CSS as unknown as { highlights?: HighlightSpeicher }).highlights;
  return h && s ? { Highlight: h, speicher: s } : null;
}

/** klein, ohne Akzente, ß als ss (wie `falten` im Server); die Karte hält fest, welches Zeichen des Originals wohin gehört */
function falten(text: string): { text: string; zuOriginal: number[] } {
  let aus = "";
  const zuOriginal: number[] = [];
  for (let i = 0; i < text.length; i++) {
    const f = text[i].toLowerCase().replace(/ß/g, "ss").normalize("NFKD").replace(/[̀-ͯ]/g, "");
    for (const c of f) {
      aus += c;
      zuOriginal.push(i);
    }
  }
  return { text: aus, zuOriginal };
}

function varianten(wort: string): string[] {
  const a = falten(wort).text;
  const b = a.replace(/ae|oe|ue/g, (m) => m[0]);
  return a === b ? [a] : [a, b];
}

export function treffer(wurzel: Element | null, suche: string): void {
  const api = schnittstelle();
  if (!api) return;
  api.speicher.delete(NAME);
  const woerter = suche.split(/\s+/).filter(Boolean).map(varianten);
  if (!wurzel || !woerter.length) return;
  const ranges: Range[] = [];
  const lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT);
  for (let n = lauf.nextNode(); n; n = lauf.nextNode()) {
    const text = n.textContent ?? "";
    if (!text.trim()) continue;
    const { text: gefaltet, zuOriginal } = falten(text);
    for (const vs of woerter) {
      for (const v of vs) {
        if (!v) continue;
        for (let von = gefaltet.indexOf(v); von >= 0; von = gefaltet.indexOf(v, von + v.length)) {
          const r = document.createRange();
          r.setStart(n, zuOriginal[von]);
          r.setEnd(n, zuOriginal[von + v.length - 1] + 1);
          ranges.push(r);
        }
      }
    }
  }
  if (ranges.length) api.speicher.set(NAME, new api.Highlight(...ranges));
}

export function trefferLoeschen(): void {
  schnittstelle()?.speicher.delete(NAME);
}
